/**
 * List of data layer resolvers names
 * @type {{CART_ADD_ITEM: string, CART_PAGE_OPEN: string, CART_REMOVE_ITEM: string, CART_FLUSH: string}}
 */
export const resolversNames = {
    CART_ADD_ITEM: 'CART_ADD_ITEM',
    CART_REMOVE_ITEM: 'CART_REMOVE_ITEM',
    CART_FLUSH: 'CART_FLUSH',
    CART_PAGE_OPEN: 'CART_PAGE_OPEN',
};

/**
 * Map which bound name with  resolver (dynamic import)
 * @type {Map<*, function(): Promise<{readonly default?: function(*=): (undefined)}>>}
 */
const mapResolvers = new Map([
    [
        resolversNames.CART_ADD_ITEM,
        () => import('~/src/utils/dataLayer/dataLayerAddToCart' /* webpackChunkName: "datalayer/addToCart" */),
    ],
    [
        resolversNames.CART_REMOVE_ITEM,
        () => import('~/src/utils/dataLayer/dataLayerRemoveFromCart' /* webpackChunkName: "datalayer/removeItem" */),
    ],
    [
        resolversNames.CART_PAGE_OPEN,
        () => import('~/src/utils/dataLayer/dataLayerCheckoutCart' /* webpackChunkName: "datalayer/openCartPage" */),
    ],
]);

/**
 * This plugin inject data layer functionality.
 *
 * @param {Object} context - special object from nuxt
 * @param {Function} inject - inject from nuxt which allow add functionality for whole app
 *
 * @return {undefined}
 */
export default function (context, inject) {
    inject('dataLayer', async ({ type, data }) => {
        if (mapResolvers.has(type)) {
            const { default: dataLayerResolver } = await mapResolvers.get(type)();
            dataLayerResolver(data);
        }
    });
}
